import { useCurrentUser } from "@hooks/use-current-user";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { isPreviewBuild } from "@lib/preview";
import { createFileRoute } from "@tanstack/react-router";
import { Avatar, AvatarFallback, AvatarImage } from "@ui/avatar";
import { Button } from "@ui/button";
import { FieldDescription, FieldLegend, FieldSet } from "@ui/field";
import { LogOutIcon } from "lucide-react";

export const Route = createFileRoute("/settings/account")({
  component: AccountSettingsComponent,
});

function AccountSettingsComponent() {
  const { user, isLoading } = useCurrentUser();
  const { logout } = useKindeAuth();

  if (isLoading || !user) {
    return null;
  }

  return (
    <div className="max-w-xl p-6">
      <FieldSet>
        <FieldLegend>Account</FieldLegend>
        <FieldDescription className="-mt-2">
          Your account information.
        </FieldDescription>
      </FieldSet>
      <div className="mt-6 flex items-center gap-4">
        <Avatar className="size-16">
          {user.picture && (
            <AvatarImage
              src={user.picture}
              alt={user.name}
              crossOrigin="anonymous"
            />
          )}
          <AvatarFallback className="text-lg">{user.initials}</AvatarFallback>
        </Avatar>
        <div>
          <div className="font-medium">{user.name}</div>
          <div className="text-gray-500 text-sm">{user.email}</div>
        </div>
      </div>
      {!isPreviewBuild() && (
        <div className="mt-6">
          <Button variant="outline" onClick={() => logout()}>
            <LogOutIcon className="mr-2 size-4" />
            Sign out
          </Button>
        </div>
      )}
    </div>
  );
}
